/*eslint-disable*/
import Cookies from 'js-cookie';

const username = process.env.REACT_APP_BASIC_AUTH_USERNAME;
const password = process.env.REACT_APP_BASIC_AUTH_PASSWORD;

export const basicAuth = btoa(`${username}:${password}`);
export const bearerToken = Cookies.get('token');
